import AppPopover from '@/components/AppPopover.vue';
import FormSelectEmployee from '@/components/form/FormSelectEmployee.vue';
import FormSelectEntity from '@/components/form/FormSelectEntity.vue';
import FormSelectRole from '@/components/form/FormSelectRole.vue';
import FormSelectUser from '@/components/form/FormSelectUser.vue';
import PersonBoxEmployee from '@/components/PersonBoxEmployee.vue';
import PersonBoxEntity from '@/components/PersonBoxEntity.vue';
import PersonBoxRole from '@/components/PersonBoxRole.vue';
import PersonBoxUser from '@/components/PersonBoxUser.vue';
// @ts-ignore
import {setMentionVueApp} from '@/components/UserContent.vue';
import {initEditor} from '@/library/froala';
import {setPopupVueApp} from '@/library/popup';
import {initSentry, setSentryVueApp} from '@/library/sentry';
import {isPlainObject} from '@/library/utils';
import RouterUtils from '@/mixins/RouterUtils';
import portuna from '@/plugins/portuna';
import ShiftEdit from '@/views/shift-schedule/ShiftEdit.vue';
import WorkGroupEdit from '@/views/shift-schedule/WorkGroupEdit.vue';
import {type ComponentOptions} from '@vue/runtime-core';
import axios from 'axios';
import localforage from 'localforage';
import {TinyEmitter} from 'tiny-emitter';
import * as Vue from 'vue';
import './filters';
import VueAxios from 'vue-axios';
import {toNative} from 'vue-facing-decorator';
// @ts-expect-error - there are no type defs for this plugin
import VueFroala from 'vue-froala-wysiwyg';
import {type Router} from 'vue-router';
import directives from './directives';
import {getUsername} from './filters/username';
import {exportEnabled, exportSettings} from './library/export';
import {uniqueId} from './library/string';
import router from './router';
import store from './store';
import {isDeveloper} from './utils/portuna';

//Import Froala Editor
import 'froala-editor/js/plugins.pkgd.min';
//Import Froala Editor Language
import 'froala-editor/js/languages/de';
//Import plugins
import 'froala-editor/js/plugins/align.min';
import 'froala-editor/js/plugins/code_view.min';
import 'froala-editor/js/plugins/colors.min';
import 'froala-editor/js/plugins/draggable.min';
import 'froala-editor/js/plugins/emoticons.min';
import 'froala-editor/js/plugins/font_family.min';
import 'froala-editor/js/plugins/font_size.min';
import 'froala-editor/js/plugins/image.min';
import 'froala-editor/js/plugins/link.min';
import 'froala-editor/js/plugins/lists.min';
import 'froala-editor/js/plugins/paragraph_format.min';
import 'froala-editor/js/plugins/paragraph_style.min';
import 'froala-editor/js/plugins/quote.min';
import 'froala-editor/js/plugins/table.min';
import 'froala-editor/js/plugins/url.min';
import 'froala-editor/js/plugins/video.min';
import 'froala-editor/js/plugins/word_paste.min';
//Overwrite Froala Editor + Plugins Language
import './library/froala_de';
// Import Froala Editor css files.
import 'froala-editor/css/froala_editor.pkgd.min.css';
import 'froala-editor/css/froala_style.min.css';
//Import plugins styles
import 'froala-editor/css/plugins/code_view.min.css';
import 'froala-editor/css/plugins/colors.min.css';
import 'froala-editor/css/plugins/draggable.min.css';
import 'froala-editor/css/plugins/emoticons.min.css';
import 'froala-editor/css/plugins/image.min.css';
import 'froala-editor/css/plugins/table.min.css';
import 'froala-editor/css/plugins/video.min.css';
//Import Mention styles
import 'tributejs/dist/tribute.css';
// import here for css score
import './stylesheet/layout/portuna_froala.scss';

// 'fontFamily', 'fontSize', 'image', 'link', 'lists', 'table', 'quote', 'paragraphFormat', 'paragraphStyle'

//<editor-fold desc="debug">
//@ts-ignore
// Vue.component('debug', {
//     name: 'debug',
//     render(createElement: any)
//     {
//         // do nothing if not a developer
//         if (!isDeveloper())
//         {
//             return '';
//         }
//
//         let element;
//         // json debug
//         if ('undefined' !== typeof this.json)
//         {
//             element = createElement(
//                 'pre',
//                 JSON.stringify(this.json, null, 2),
//             );
//         }
//         else
//         {
//             element = createElement(
//                 'span',
//                 'no debug found',
//             );
//         }
//         return element;
//     },
//     props: {
//         json: {
//             type: [Object, Array, String, Number, Boolean],
//             required: false,
//             default: undefined,
//         },
//     },
// });
//</editor-fold>

// axios defaults
axios.defaults.headers['X-Requested-With']  = 'XMLHttpRequest';
axios.defaults.headers['X-Requested-By']    = 'spa';
axios.defaults.headers['Cache-Control']     = 'no-cache';
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

// localForage defaults
localforage.config({
    name: 'portunaStorage',
});

export function initVueApp(app: Vue.App<Element>, customRouter: Nullable<Router> = null, styleguide = false)
{
    axios.interceptors.request.use((config) =>
    {
        if (isPlainObject(config.data))
        {
            // make sure correct request content-type is set to avoid automatic axios serialization of config.data
            config.headers['Content-Type'] = 'application/json';
        }

        return config;
    });

    axios.interceptors.response.use(undefined, (error) =>
    {
        if (/*error instanceof Error &&*/ 'undefined' !== typeof error.response)
        {
            console.log('[Axios]', error.response.status, error.response.data.error, error.response);
            if (error.response.status === 403 && error.response.data.error === 'login-required')
            {
                if (!styleguide)
                {
                    store.dispatch('logout', customRouter ?? router).catch(() => console.error('logout failed'));
                }
                else
                {
                    return Promise.resolve(true);
                }

            }
            if (error.response.status === 503 && error.response.data.error === 'error-maintenance-active')
            {
                router.push({
                    name: 'maintenance',
                    replace: true,
                    params: {message: error.response.data.message},
                }).catch(console.error);
            }
            else if (isDeveloper())
            {
                store.commit('addError', error);
            }
        }

        return Promise.reject(error);
    });

    let viewPortSize: ViewSize = {
        xs: false,
        xsDown: false,
        xsUp: false,
        sm: false,
        smDown: false,
        smUp: false,
        md: false,
        mdDown: false,
        mdUp: false,
        lg: false,
        lgDown: false,
        lgUp: false,
        xl: false,
        xlDown: false,
        xlUp: false,
        xxl: false,
        xxlDown: false,
        xxlUp: false,
    };

    let viewSize: ViewSize = {
        xs: false,
        xsDown: false,
        xsUp: false,
        sm: false,
        smDown: false,
        smUp: false,
        md: false,
        mdDown: false,
        mdUp: false,
        lg: false,
        lgDown: false,
        lgUp: false,
        xl: false,
        xlDown: false,
        xlUp: false,
        xxl: false,
        xxlDown: false,
        xxlUp: false,
    };

    app.use(VueAxios, axios);
    app.use(store);
    app.use(customRouter ? customRouter : router);
    app.use(VueFroala);
    app.use(portuna);

    app.mixin({
        data()
        {
            return {
                emitter: new TinyEmitter(),
                viewPortSize,
                viewSize,
                _uid: uniqueId(),
            };
        },
        // also runs on setup components
        mounted()
        {
            // catch special behavior of mixins corrupting setup component instances
            if (this.$options.name !== 'RouterUtils')
            {
                this.$el.__vue__ = this;
            }
        },
        // also runs on setup components
        updated()
        {
            // case v-if was false after mounted#
            // catch special behavior of mixins corrupting setup component instances
            if (this.$el && !this.$el.hasOwnProperty('__vue__') && this.$options.name !== 'RouterUtils')
            {
                this.$el.__vue__ = this;
            }
        },
        methods: {
            getUsername,
        },
        computed: {
            currentExportSettings(): Partial<InternalExportData>
            {
                return exportSettings();
            },
            isExportRequest(): boolean
            {
                return exportEnabled();
            },
            isStyleguide(): boolean
            {
                return false;
            },
            currentUser(): CurrentUser
            {
                return this.$store.state.layoutData.user;
            },
        },
        directives: directives,
    });

    app.mixin(toNative(RouterUtils) as unknown as ComponentOptions);

    setPopupVueApp(app);
    setMentionVueApp(app);
    setSentryVueApp(app);
    initEditor();

    if (process.env.NODE_ENV === 'production' && process.env.IS_STAGING && !process.env.IS_DEV)
    {
        initSentry();
    }

    // global components
    app.component('AppPopover', AppPopover);
    app.component('FormSelectUser', FormSelectUser);
    app.component('FormSelectEntity', FormSelectEntity);
    app.component('FormSelectEmployee', FormSelectEmployee);
    app.component('FormSelectRole', FormSelectRole);
    app.component('PersonBoxUser', PersonBoxUser);
    app.component('PersonBoxRole', PersonBoxRole);
    app.component('PersonBoxEmployee', PersonBoxEmployee);
    app.component('PersonBoxEntity', PersonBoxEntity);
    app.component('WorkGroupEdit', WorkGroupEdit);
    app.component('ShiftEdit', ShiftEdit);
}